import React, { Component } from 'react';
import Prismic from 'prismic-javascript';
import { withRouter } from 'react-router';
import { PrismicConfigMarketingPage } from '../../../../helpers/prismicHelpers/PrismicAPI';
import { articlesListHelper, categoriesHelper } from "../../../../helpers/prismicHelpers/prismic-custom-helpers/BlogHelpers";
import Loader from '../../../common/elements/Loader';
import CategoryMenu from './CategoryMenu';
import BlogSearchForm from './BlogSearchForm';
import { BlogListArticles } from './BlogListArticles';
import { PaginationComponent } from "../../../common/elements/PaginationComponent";
import { siteOfOriginHelper } from '../../../../../client/helpers/genericHelpers';
import ThemePageBanner from '../../../dashboardNew/components/ThemePageBanner';

class BlogsMainPage extends Component {

    state = {
        loading: true,
        articlesList: null,
        pagination: null,
        pageNumber: null,
        queryQuestion: null,
        categoryName: null,
        categories: null,
        error: false,
        json: null
    }

    componentDidMount() {
        this.getArticles()
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.location.query.page !== this.state.pageNumber) {
            this.setState({
                loading: true
            });
            this.getArticles()
        }
    }

    getArticles = async () => {
        const {
            page,
            question,
            category
        } = this.props.location.query
        const pageNumber = page ? page : 1;
        const queryQuestion = question ? decodeURI(question) : null;
        const categoryName = category ? category : null;

        try {
            const prismicConnection = await Prismic.api(PrismicConfigMarketingPage.apiEndpoint, { accessToken: PrismicConfigMarketingPage.apiAccessToken });
            const languagePrismic = { lang: `en-${siteOfOriginHelper()}` }

            //Key value pairs to fetch on list page
            const arrayToFetch = [
                "blog-single-article.uid",
                "blog-single-article.article_small_img",
                "blog-single-article.article_big_img",
                "blog-single-article.article_date",
                "blog-single-article.alternative_text_image",
                "blog-single-article.article_title",
                "blog-single-article.article_short_description",
                "blog-single-article.author",
                "blog-single-article.category_id",
                "blog-single-article.is_on_portal"
            ];

            const queryOptions = {
                orderings: "[my.blog-single-article.article_date desc]",
                fetch: arrayToFetch,
                pageSize: Number(pageNumber) === 1 ? 9 : 8,
                page: pageNumber,
                ...languagePrismic
            };

            let queryToGetArticles;

            if (!queryQuestion && !categoryName) {
                queryToGetArticles = prismicConnection.query(
                    [
                        Prismic.Predicates.at("document.type", "blog-single-article")
                    ],
                    queryOptions
                )
            } else if (queryQuestion && queryQuestion.length > 0 && !categoryName) {
                queryToGetArticles = prismicConnection.query(
                    [
                        Prismic.Predicates.at("document.type", "blog-single-article"),
                        Prismic.Predicates.fulltext('document', queryQuestion)
                    ],
                    queryOptions
                )
            } else if (categoryName && categoryName.length > 0 && !queryQuestion) {
                queryToGetArticles = prismicConnection.query([
                        Prismic.Predicates.at("document.type", "blog-single-article"),
                        Prismic.Predicates.fulltext('my.blog-single-article.category_name', categoryName),
                    ],
                    queryOptions
                )
            } else if (queryQuestion && categoryName) {
                queryToGetArticles = prismicConnection.query([
                        Prismic.Predicates.at("document.type", "blog-single-article"),
                        Prismic.Predicates.fulltext('my.blog-single-article.category_name', categoryName),
                        Prismic.Predicates.fulltext('document', queryQuestion)
                    ],
                    queryOptions
                )
            }

            const json = await Promise.all([
                queryToGetArticles,
                prismicConnection.query(Prismic.Predicates.at("document.type", "blog-categories"), languagePrismic)
            ]);

            const { articlesList } = articlesListHelper(json[0], categoriesHelper(json[1]));

            // When we have all the data we need
            this.setState({
                loading: false,
                articlesList,
                pagination: {
                    page: json[0].page,
                    results_per_page: json[0].results_per_page,
                    total_pages: json[0].total_pages,
                    results_size: json[0].results_size,
                    total_results_size: json[0].total_results_size
                },
                pageNumber,
                queryQuestion,
                categoryName,
                ...categoriesHelper(json[1])
            })
        } catch (err) {
            console.log(err)
            this.setState({ error: true })
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.articlesList !== nextState.articlesList) return true
        if (this.state.categories !== nextState.categories) return true
        if (this.state.loading !== nextState.loading) return true
        return false
    }

    handlePageChange = (e) => {
        const {
            queryQuestion,
            categoryName
        } = this.state;
        this.props.router.push(`/blog?page=${e}&${queryQuestion ? `question=${encodeURI(queryQuestion)}&` : ''}${categoryName ? `category=${categoryName}&` : ''}`)
    }

    render() {

        const {
            loading,
            articlesList,
            pagination,
            pageNumber,
            queryQuestion,
            categoryName,
            categories,
            error
        } = this.state;

        if (!articlesList || !categories || loading) return <Loader />

        if (error) return (
            <div className="container margin-top margin-bottom">
                <h1 className="h1">Something went wrong, please try again.</h1>
            </div>
        )

        return (
            <div className="container-fluid blog-list-page">
                <ThemePageBanner heading='The Networking Blog' image='/images/blog-header.jpg'/>
                {categories && <CategoryMenu categories={categories} current_category={categoryName} queryQuestion={queryQuestion} />}

                <section className="container">
                    <div className="blog-overview__list" id="blogs__list">
                        <BlogListArticles
                            articlesList={articlesList}
                            pageNumber={pageNumber}
                        />
                    </div>
                </section>

                {
                    articlesList && articlesList.length > 0 && pagination.total_pages > 1 && (
                        <React.Fragment>
                            <div className="hidden-xs">
                                <PaginationComponent
                                    activePage={pagination.page}
                                    itemsCountPerPage={pagination.results_per_page}
                                    totalItemsCount={pagination.total_results_size}
                                    pageRangeDisplayed={3}
                                    onChange={this.handlePageChange}
                                />
                            </div>
                            <div className="hidden-sm hidden-md hidden-lg">
                                <PaginationComponent
                                    activePage={pagination.page}
                                    itemsCountPerPage={pagination.results_per_page}
                                    totalItemsCount={pagination.total_results_size}
                                    pageRangeDisplayed={1}
                                    onChange={this.handlePageChange}
                                />
                            </div>
                        </React.Fragment>
                    )
                }

            </div>
        )
    }
}

export default withRouter(BlogsMainPage);



// WEBPACK FOOTER //
// src/client/components/site/features/blogs/BlogsMainPage.js